import React from "react";
import { Globe, ExternalLink } from "lucide-react";
import type { CitationSource } from "@/lib/chat/citations";

interface SourcesFooterProps {
  sources: CitationSource[];
}

export const SourcesFooter: React.FC<SourcesFooterProps> = ({ sources }) => {
  if (sources.length === 0) return null;

  return (
    <div className="mt-4 pt-3 border-t border-border/40">
      <p className="text-xs font-medium text-muted-foreground mb-2">
        Sources
      </p>
      <div className="flex flex-wrap gap-2">
        {sources.map((source) => (
          <a
            key={source.index}
            href={source.url}
            target="_blank"
            rel="noopener noreferrer"
            className="
              group/source inline-flex items-center gap-1.5
              rounded-lg border border-border/60 
              bg-muted/30 hover:bg-muted/60
              px-2.5 py-1.5
              text-xs text-muted-foreground hover:text-foreground
              no-underline transition-colors duration-150
              max-w-[200px]
            "
          >
            <span className="flex items-center justify-center h-4 w-4 rounded-full bg-primary/10 text-primary text-[0.6rem] font-semibold flex-shrink-0">
              {source.index}
            </span>
            <Globe className="h-3 w-3 flex-shrink-0 text-muted-foreground/60" />
            <span className="truncate">{source.hostname}</span>
            <ExternalLink className="h-3 w-3 flex-shrink-0 opacity-0 group-hover/source:opacity-100 transition-opacity" />
          </a>
        ))}
      </div>
    </div>
  );
};
